export const feeds = [
    {
        Imagem: '../../../assets/img/feed/feed-img1.jpg',
        Data: '26 December 2019',
        Titulo: 'Slider 1',
        Texto: `Lorem ipsum dolor sit amet consectetur, 
        adipisicing elit. Recusandae voluptate repellendus magni illo ea animi? `,
    }, {
        Imagem: '../../assets/img/feed/feed-img2.jpg',
        Data: '26 December 2019',
        Titulo: 'Slider 2',
        Texto: `Lorem ipsum dolor sit amet consectetur, 
        adipisicing elit. Recusandae voluptate repellendus magni illo ea animi? `,
    }, {
        Imagem: '../../assets/img/feed/feed-img3.jpg',
        Data: '26 December 2019',
        Titulo: 'Slider 3',
        Texto: `Lorem ipsum dolor sit amet consectetur, 
        adipisicing elit. Recusandae voluptate repellendus magni illo ea animi? `,
    }

]